/* eslint-disable max-lines */
import { startCase } from 'lodash';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getAllUsersPermissionsCounts,
  getSelectedUsersPermissionsCounts,
} from 'selectors/userPermissionsPage';

type ComponentProps = {
  selectedUsersOnly?: boolean;
};

const UsersStats: React.FC<ComponentProps> = ({ selectedUsersOnly = true }) => {
  const selectedUsersPermissionsCounts = useSelector(getSelectedUsersPermissionsCounts);
  const allUsersPermissionsCounts = useSelector(getAllUsersPermissionsCounts);

  const permissions = selectedUsersOnly
    ? selectedUsersPermissionsCounts
    : allUsersPermissionsCounts;

  const { roles, divisions, regions, managementLevels, insight, prevent } = permissions;

  return (
    <div className="pt-2 px-3 pb-4 flex flex-col justify-between bg-white">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <span className="italic">Role</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(roles).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-1">
          <span className="italic">Division(s)</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(divisions).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-1">
          <span className="italic">Region</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(regions).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-1">
          <span className="italic">Management Level</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(managementLevels).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-1">
          <span className="italic">Insight</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(insight).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-1">
          <span className="italic">Prevent</span>

          <ul className="list-disc list-outside pl-7">
            {Object.entries(prevent).map(([label, count]) => (
              <li key={label}>
                {startCase(label)}: {count} {pluralize('User', count)}{' '}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UsersStats;
